import { UseSuspenseQueryOptions, useMutation, useQueryClient } from '@tanstack/react-query';

import { Id } from '@feature/utils';
import { Validation } from '@feature/validation';
import { generateValidationApi, generateValidationOptions } from '@feature/validation/validationGenerator';

const validationApi = generateValidationApi('/validation/presentation');

const { getHistoryOptions, validateOptions, getCurrentOptions } = generateValidationOptions(
  'presentation',
  validationApi,
);

export function getPresentationValidationHistoryOptions(presentationId: Id): UseSuspenseQueryOptions<Validation[]> {
  return getHistoryOptions(presentationId);
}

export function getPresentationValidationOptions(presentationId: Id): UseSuspenseQueryOptions<Validation | null> {
  return getCurrentOptions(presentationId);
}

export function useValidatePresentation(presentationId: Id) {
  const queryClient = useQueryClient();
  return useMutation(validateOptions(presentationId, queryClient));
}
